import React from "react";
import starIcon from "../../images/star-icon.png";
import { renderText } from "./renderText";
import { HighlightText } from "./HighlightText";

const SectionTitle = ({ data }) => {
  return (
    <div className="section-title" data-aos="fade-up" data-aos-duration="1200">
      {data.subtitle && (
        <span className="sub-title">
          <img src={starIcon} alt="feature" />
          {data.subtitle}
        </span>
      )}
      {/* {data.title && <h2 className="text-center">{data?.title}</h2>} */}
      {data.title && <h2 className="text-center">
        <HighlightText content={data?.title} />
        </h2>}

      {/* {data.description && <p>{data.description}</p>} */}
      {data?.description &&
        (typeof data.description === "string" ? (
          <p>{data.description}</p>
        ) : (
          data.description.map((block, index) => {
            switch (block.type) {
              case "paragraph":
                return (
                  <p key={index}>
                    {block.children.map((c) => c.text).join("")}
                  </p>
                );

              case "heading":
                const Tag = `h${block.level}`;
                return (
                  <Tag key={index} className="mt-4 mb-3">
                    {block.children.map((c) => c.text).join("")}
                  </Tag>
                );

              case "list":
                return (
                  <ul key={index} className="list-unstyled">
                    {block.children.map((item, i) => (
                      <li key={i} className="features-text">
                        <h4>
                          <i className="flaticon-tick"></i>{" "}
                          {item.children.map((c) => c.text).join("")}
                        </h4>
                      </li>
                    ))}
                  </ul>
                );

              default:
                return null;
            }
          })
        ))}
      {data?.richText?.map((block, index) => {
        switch (block.type) {
          case "paragraph":
            return <p key={index}>{renderText(block.children)}</p>;

          case "heading":
            const Tag = `h${block.level}`;
            return (
              <Tag key={index} className="mt-4 mb-3">
                {block.children.map((c) => c.text).join("")}
              </Tag>
            );
          case "list":
            const ListTag = block.format === "ordered" ? "ol" : "ul";

            return (
              <ListTag key={index} className="list-unstyled">
                {block.children.map((item, i) => (
                  <li key={i} className="features-text">
                    <h4>
                      <i className="flaticon-tick"></i>
                      <span>
                        {item.children.map((child, j) => {
                          const isBold =
                            child.bold ||
                            child.marks?.some((mark) => mark.type === "bold");

                          if (isBold) {
                            return <b key={j}>{child.text}</b>;
                          }

                          return child.text;
                        })}
                      </span>
                    </h4>
                  </li>
                ))}
              </ListTag>
            );

          default:
            return null;
        }
      })}
    </div>
  );
};

export default SectionTitle;
